<template>
  <div style="position: relative">
    <!-- dropdown body-->
    <div class="dropdown-wrapper" :class=" {'active': showOptions}" v-on-clickaway="blurred ">
      <!-- dropdown ends -->
      <!-- placeholder/displayed value-->
      <div
        @click="showOptions=!showOptions&&!disabled"
        class="input-box"
        :class=" {'active': showOptions, 'disabled': disabled}"
      >
        <!-- default placeholder-->
        <div
          class="placeholder-div"
          v-if="!search"
        >{{selecteditem != '' ? selecteditem : defaultValue}}</div>
        <!-- input field is only displayed when search is enabled-->
        <div class="placeholder-div" v-else>
          <input class="search-input" v-model="searchItem" :disabled="disabled" v-if="search" />
        </div>
        <i v-if="!disabled" class="fa fa-caret-down"></i>
      </div>
      <!-- placeholder/displayed value ends-->
      <!-- dropdown -->
      <div class="options-wrapper" v-if="showOptions">
        <!-- dropdown option-->
        <!-- we are binding clickaway directive here-->
        <div
          class="option-item"
          v-for="(option, index) in filteredList"
          :key="index"
          v-on-clickaway="function(){showOptions=false}"
          @click="selectOption(option)"
        >
          <span v-if="typeof option == 'string'">{{option}}</span>
          <span v-else>{{option.name}}</span>
        </div>
      </div>
      <!-- dropdown ends -->
    </div>
    <!--dropdown body ends-->
  </div>
</template>

<script>
// Using vue-clickaway library for clickaway directive, i.e
// dropdown closes when clicked anywhere else on the screen

import { directive as onClickaway } from "vue-clickaway";
const _ = require("lodash");
export default {
  name: "dropdown",
  data() {
    return {
      selecteditem: "",
      showOptions: false, // dropdown is opened when true
      selectedList: [], // array of selected options. Used for multiselect
      searchItem: "" // String to be searched for. Used for multiselect
    };
  },
  directives: {
    onClickaway: onClickaway
  },
  props: {
    optionlist: Array, // takes the list of options for dropdown
    multiselect: {
      // Enables multiselecting
      type: Boolean,
      default: false
    },
    search: {
      // enables search
      type: Boolean,
      default: false
    },
    index: {
      // returns the index of the selected option in the list of options
      type: Number,
      default: 0
    },
    hiddenonclick: {
      // closes dropdown on selecting an option if true
      default: true,
      type: Boolean
    },
    removeditems: Array, // takes a list of already selected items to remove from dropdown
    defaultValue: String, // placeholder
    defaultSelected: null, // default selected value
    disabled: {
      // disable the dropdown
      default: false,
      type: Boolean
    },
    hideselected: {
      // hides selected items on true
      default: false,
      type: Boolean
    }
  },
  computed: {
    filteredList() {
      // filtering undefined values from the optionslist
      var filtered = this.optionlist.filter(option => option != undefined);
      if (this.multiselect) {
        this.selectedList = _.clone(this.removeditems);
        filtered = filtered.filter(
          option => this.selectedList.indexOf(option) == -1
        );
      }
      if (this.search) {
        filtered = filtered.filter(option => {
          if (typeof option == "string")
            return option.toLowerCase().includes(this.searchItem);
          return option.name.toLowerCase().includes(this.searchItem);
        });
      }
      //   if(typeof filtered[0] == "string");
      return filtered;
    }
  },
  watch: {
    // sets a value as selected when the defaultSelected prop is provided
    defaultSelected: function(newVal, oldVal) {
      this.selectOption(newVal);
    }
  },
  methods: {
    // emits a select event with selected option data
    selectOption(option) {
      if (typeof option == "string") this.selecteditem = option;
      else this.selecteditem = option.name;

      if (this.hiddenonclick && !this.multiselect) {
        this.showOptions = false;
      }
      if (this.selectedList.indexOf(option) == -1) {
        this.selectedList.push(option);
      }
      // option is the selected option value and index is its index in the passed options array
      this.$emit("select", { option: option, index: this.index });
    },
    blurred() {
      this.showOptions = false;
    }
  },
  mounted() {
    // sets a value as selected when the defaultSelected prop is provided
    if (this.defaultSelected != null) {
      this.selectedList = [];
      this.selectOption(this.defaultSelected);
    }
  }
};
</script>

<style scoped>
.dropdown-wrapper {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  height: max-content;
  width: 100%;
  line-height: 38px;
  margin: auto;
}

.option-item,
.input-box {
  background: #ffffff;
  height: 38px;
  width: 100%;
  line-height: 38px;
  z-index: 100;
  padding: 0px 10px 0px 10px;
  position: relative;
}

.option-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.options-wrapper {
  max-height: 190px;
  overflow-y: auto;
  position: absolute;
  top: 39px;
  width: 100%;
  border: 1px solid #b4b4b4;
  background: #fff;
  z-index: 101;
  left: 0px;
}

.option-item:hover {
  background: #24c656;
  color: white;
}

.placeholder-div {
  display: inline-block;
  width: calc(100% - 14px);
}

.input-box.active {
  border-bottom: 1px solid #f2f2f2;
  border-radius: 4px;
}

.disabled {
  background: #fbfbfb;
}
</style>
